<template>
  <div class="signup-view">
    <Signup />
  </div>
</template>

<script>
import Signup from "@/components/templates/Signup";

export default {
  components: { Signup },
};
</script>